import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import YearOutcomesTable from "../Statistics/YearOutcomesTable";
import { useYearFilters, YearFilters } from "../Statistics/YearFilters";

// Conseil de classe : saisie de la décision annuelle de chaque étudiant
// (admis, passant avec crédits, redoublant, sortant, exclu), filtrée par
// année universitaire, semestre (colonne moyenne), spécialité et classe.
const ClassCouncil = () => {
  const { t } = useTranslation();
  const filters = useYearFilters();

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">{t("menu.dashboard.title")}</Link>
                </li>
                <li className="breadcrumb-item active">{t("menu.results.classCouncil")}</li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="card">
          <div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
            <h5 className="mb-0">{t("menu.results.classCouncil")}</h5>
            <YearFilters filters={filters} />
          </div>
          <div className="card-body">
            {filters.yearId && (
              <YearOutcomesTable
                academicYearId={filters.yearId}
                semesterId={filters.semesterId}
                departmentId={filters.departmentId}
                classId={filters.classId}
                extraParams={{
                  level_id: filters.levelId || undefined,
                  group_id: filters.groupId || undefined,
                  student_status: filters.studentStatus || undefined,
                  subject_id: filters.subjectId || undefined,
                  exam_id: filters.examId || undefined,
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassCouncil;